/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Setup_NeededInputs */

const cs_portals_setup_needed = /** @type {(inputs: Portals_Setup_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doplňte údaje v Nastavení → Portály`)
};

const en_portals_setup_needed = /** @type {(inputs: Portals_Setup_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add credentials in Settings → Portals`)
};

/**
* | output |
* | --- |
* | "Add credentials in Settings → Portals" |
*
* @param {Portals_Setup_NeededInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_setup_needed = /** @type {((inputs?: Portals_Setup_NeededInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Setup_NeededInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_setup_needed(inputs)
	return cs_portals_setup_needed(inputs)
});